import React, { useState, useEffect, Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../components/LoadingSpinner';

const LandingPageArabic = lazy(() => import('./LandingPageArabic').catch(() => ({
    default: () => <div className="min-h-screen flex items-center justify-center text-white bg-bg-main">Failed to load content. Please refresh the page.</div>
})));
const LandingPageSpanish = lazy(() => import('./LandingPageSpanish').catch(() => ({
    default: () => <div className="min-h-screen flex items-center justify-center text-white bg-bg-main">Failed to load content. Please refresh the page.</div>
})));

const LandingPage = () => {
    const { i18n } = useTranslation();

    // Use current language to decide which component to render
    const isArabic = i18n.language.startsWith('ar');

    return (
        <Suspense fallback={<LoadingSpinner />}>
            {isArabic ? <LandingPageArabic /> : <LandingPageSpanish />}
        </Suspense>
    );
};

export default LandingPage;
